import type { MouseEvent, ReactNode } from 'react'
import { cx } from './internal/cx'
import './IconButton.css'

export type IconButtonProps = {
  /** Required accessible name; icon-only buttons never rely on the icon alone. */
  'aria-label': string
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  variant?: 'ghost' | 'filled' | 'danger'
  children: ReactNode
}

/** 44×44 icon-only button. The child is a decorative line icon. */
export function IconButton({
  'aria-label': ariaLabel,
  onClick,
  disabled = false,
  variant = 'ghost',
  children,
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={cx('ui-icon-btn', `ui-icon-btn--${variant}`)}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
